import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 15000,
  withCredentials: true,
  xsrfCookieName: 'autosquare_resource_csrf',
  xsrfHeaderName: 'X-CSRFToken',
})

export default api
